import { FlexibleImageModel } from '@services/flexible_component/mod';
import { rem } from '@visiba/std';
import styled from 'styled-components';

interface Props {
	component: FlexibleImageModel;
}

const elements = {
	// We don't want layout shifting during load. Swap the entire thing to an
	// <Image /> component once it's available.
	container: styled.div<{ width: number; height: number }>`
		width: ${({ width }) => width}px;
		height: ${({ height }) => height}px;
		flex-shrink: 0;
	`,
	image: styled.img`
		height: 100%;
		width: 100%;
		border-radius: ${rem(16)};
		object-fit: cover;
	`,
};

export function FlexibleImage({ component }: Props): JSX.Element {
	return (
		<elements.container width={component.imageWidth} height={component.imageHeight}>
			<elements.image
				data-testid='FlexibleImage'
				src={component.imageUrl}
				alt={component.altText}
				height={component.imageHeight ?? 720}
				width={component.imageWidth ?? 720}
			/>
		</elements.container>
	);
}
